import React, { FC } from 'react';
import { Bar } from 'react-chartjs-2';

interface Props {
    data: any
}

const options: any = {
    indexAxis: 'y',
    // Elements options apply to all of the options unless overridden in a dataset
    // In this case, we are setting the border of each horizontal bar to be 2px wide
    elements: {
        bar: {
            borderWidth: 2,
        },
    },
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
        },
        title: {
            display: true,
            text: 'Live Data',
        },
    },
};
const Graphs: FC<Props> = ({ data }) => {
    console.log(data);
    return (
        <>
            {Object.keys(data).length === 0 === false &&
                <Bar data={data} options={options} />
            }
        </>
    )
}

export default Graphs